import { PureComponent } from 'react';

import BlackFriday from 'Component/BlackFriday';

import { getUrlParam } from 'Util/Url';

export class BlackFridayPage extends PureComponent {
    render() {
        const { location, match } = this.props;

        const urlKey = getUrlParam(match, location);

        return (
            <BlackFriday slug={ urlKey } />
        );
    }
}

export default BlackFridayPage;
